import {
  BiArrowsAngleContract,
  BiArrowsAngleExpand,
  BiArrowsFullscreen,
  BiBarChartFill,
  BiCalendar2DayFill,
  BiCalendar2EventFill,
  BiCalendar2Fill,
  BiCalendar2MonthFill,
  BiCalendar2RangeFill,
  BiCalendar2WeekFill,
  BiChatDots,
  BiCheck2All,
  BiCheckAll,
  BiClock,
  BiClockFill,
  BiClockHistory,
  BiCloudSlash,
  BiCloudUploadFill,
  BiDiagram3Fill,
  BiFileEarmarkPlus,
  BiFiletypePdf,
  BiFileWord,
  BiFlagFill,
  BiHandIndexFill,
  BiHandIndexThumbFill,
  BiLink45Deg,
  BiMarkdown,
  BiMarkdownFill,
  BiMegaphoneFill,
  BiPatchCheck,
  BiPersonBadge,
  BiShieldLock,
  BiShieldLockFill,
  BiSnow,
  BiTable,
  BiUiChecks,
  FaCalendarWeek,
  FaChartLine,
  FaCity,
  FaClock,
  FaEnvelope,
  FaFacebookF,
  FaHourglassHalf,
  FaLinkedinIn,
  FaPeopleCarry,
  FaPinterestP,
  FaRedditAlien,
  FaRobot,
  FaTelegramPlane,
  FaTwitter,
  FaUniversalAccess,
  FaWhatsapp,
  FiSquareEs,
  FiSquareMx,
  FiSquareUm,
  FiSquareUs,
  GiBookmarklet,
  GiMechaHead,
  GiMonoWheelRobot,
  GiOrganigram,
  GiQuillInk,
  GiRobotAntennas,
  GiRobotGolem,
  GiRobotHelmet,
  GiTeamIdea,
  GiTrackedRobot,
  GiVintageRobot,
  HiBadgeCheck,
  HiSolidBadgeCheck,
  HiSolidBookOpen,
  HiSolidIdentification,
  HiSolidNewspaper,
  IoArrowRedoSharp,
  IoArrowUndoSharp,
  IoBarChartSharp,
  IoCart,
  IoCogOutline,
  IoNewspaper,
  IoPeopleCircleOutline,
  IoSchoolOutline,
  LaCalendarDaySolid,
  LaChartLineSolid,
  LaCitySolid,
  LaGlobeSolid,
  LaNewspaper,
  LaRobotSolid,
  LaSchoolSolid,
  LaSpinnerSolid,
  LaUniversalAccessSolid,
  MdAddchart,
  MdArticle,
  MdAssignmentind,
  MdAutograph,
  MdChecklist,
  MdCroplandscapeSharp,
  MdCropportraitSharp,
  MdDashboardcustomizeOutlined,
  MdDashboardcustomizeTwotone,
  MdFlag,
  MdFormatlistnumbered,
  MdGroups,
  MdList,
  MdStackedlinechart,
  OiChecklist,
  PrCheckSquare,
  PrSpinner,
  PxChartMultiple,
  RiBarChart2Fill,
  RiCheckboxCircleLine,
  RiCheckboxMultipleLine,
  RiDashboard3Fill,
  RiDashboard3Line,
  RiDonutChartFill,
  RiLineChartFill,
  RiListOrdered,
  RiOrganizationChart,
  RiPieChart2Fill,
  RiRadioButtonLine,
  SiOpenai,
  ViDefaultFile,
  ViDefaultFolderOpened,
  ViFileTypeAi,
  ViFileTypeAudio,
  ViFileTypeExcel,
  ViFileTypePdf,
  ViFileTypePhotoshop,
  ViFileTypePowerpoint,
  ViFileTypeVideo,
  ViFileTypeWord,
  ViFileTypeXml,
  ViFileTypeZip,
} from 'oh-vue-icons/icons'

export const allIcons = {
  BiCalendar2DayFill,
  BiCalendar2WeekFill,
  BiCalendar2MonthFill,
  BiCalendar2RangeFill,
  BiCalendar2EventFill,
  BiCalendar2Fill,
  BiArrowsAngleContract,
  BiArrowsAngleExpand,
  BiArrowsFullscreen,
  BiBarChartFill,
  BiChatDots,
  BiCheck2All,
  BiCheckAll,
  BiClock,
  BiClockFill,
  BiClockHistory,
  BiCloudUploadFill,
  BiFileEarmarkPlus,
  BiFlagFill,
  BiHandIndexFill,
  BiHandIndexThumbFill,
  BiLink45Deg,
  BiMarkdown,
  BiMarkdownFill,
  BiMegaphoneFill,
  BiPatchCheck,
  BiPersonBadge,
  BiShieldLock,
  BiShieldLockFill,
  BiSnow,
  BiTable,
  BiUiChecks,
  FaChartLine,
  FaCity,
  FaClock,
  FaHourglassHalf,
  FaCalendarWeek,
  FaEnvelope,
  FaFacebookF,
  FaLinkedinIn,
  FaPeopleCarry,
  FaPinterestP,
  FaRedditAlien,
  FaRobot,
  FaTelegramPlane,
  FaTwitter,
  FaUniversalAccess,
  FaWhatsapp,
  FiSquareEs,
  FiSquareMx,
  FiSquareUm,
  FiSquareUs,
  GiBookmarklet,
  GiMonoWheelRobot,
  GiOrganigram,
  GiRobotAntennas,
  GiRobotGolem,
  GiRobotHelmet,
  GiTeamIdea,
  GiTrackedRobot,
  GiVintageRobot,
  HiBadgeCheck,
  HiSolidBadgeCheck,
  HiSolidIdentification,
  IoBarChartSharp,
  IoCart,
  IoCogOutline,
  IoNewspaper,
  IoPeopleCircleOutline,
  LaChartLineSolid,
  LaGlobeSolid,
  LaNewspaper,
  LaRobotSolid,
  LaCitySolid,
  LaSpinnerSolid,
  LaUniversalAccessSolid,
  MdAddchart,
  MdArticle,
  MdAssignmentind,
  MdAutograph,
  MdChecklist,
  MdCroplandscapeSharp,
  MdCropportraitSharp,
  MdFlag,
  MdFormatlistnumbered,
  MdGroups,
  MdList,
  MdStackedlinechart,
  OiChecklist,
  PrCheckSquare,
  PrSpinner,
  PxChartMultiple,
  RiBarChart2Fill,
  RiCheckboxCircleLine,
  RiCheckboxMultipleLine,
  RiDashboard3Line,
  RiDashboard3Fill,
  RiDonutChartFill,
  RiLineChartFill,
  RiListOrdered,
  RiOrganizationChart,
  RiPieChart2Fill,
  RiRadioButtonLine,
  ViDefaultFile,
  ViDefaultFolderOpened,
  ViFileTypeAi,
  ViFileTypeAudio,
  ViFileTypeExcel,
  ViFileTypePdf,
  ViFileTypePhotoshop,
  ViFileTypePowerpoint,
  ViFileTypeVideo,
  ViFileTypeWord,
  ViFileTypeXml,
  ViFileTypeZip,
  MdDashboardcustomizeOutlined,
  MdDashboardcustomizeTwotone,
  IoSchoolOutline,
  HiSolidNewspaper,
  LaSchoolSolid,
  GiQuillInk,
  SiOpenai,
  BiCloudSlash,
  LaCalendarDaySolid,
  IoArrowRedoSharp,
  IoArrowUndoSharp,
  GiMechaHead,
  BiFiletypePdf,
  BiFileWord,
  HiSolidBookOpen,
  BiDiagram3Fill,
}
